import { Injectable } from '@angular/core';
import { SysshServicePkg } from './sysshPkg.service';
import { Syssh } from '../_entity_sys';

//1:網頁 2:圖檔 3:文件檔 4:html 5:markdown
export const SysSh006List =  [ { id:"1" , name:"網頁" },{ id:"2" , name:"圖檔" },{ id:"3" , name:"文件檔" },{ id:"4" , name:"html" },{ id:"5" , name:"markdown" } ] ; // 頻率類型

@Injectable({
  providedIn: 'root',
})
export class SysshService extends SysshServicePkg {
  SysSh006List= SysSh006List;
  constructor() {
    super();
  }
  override async newRecord(newItem:Syssh): Promise<Syssh> {
  await  super.newRecord(newItem);
    newItem.SH013 = 'PACKAGE';
    return newItem;
  }
  content(): string {
    return this.item.SH019 || '';
  }

}
